export const idioma =
{
    base: 'es',
    es: {
        buscar: 'Buscar',
        cargando: 'Cargando...',
        formatofecha: 'dd-MM-yyyy',
        aceptar: 'Aceptar',
        filtrar: 'Filtrar',
        vistaimpresion: 'Vista impresión',
        basedatos: 'Base de datos',
        borrar: 'Borrar',
        borrarinquilino: 'Borrar inquilino',
        borrarperfil: 'Borrar perfil',
        borrarusuario: 'Borrar usuario',
        cancelar: 'Cancelar',
        cargacliente: 'Carga de Cliente',
        cargainquilino: 'Carga de inquilino',
        cargaperfil: 'Carga de Perfil',
        cargausuario: 'Carga de Usuario',
        codigo: 'Código',
        compania: 'Compañia',
        contrasena: 'Contraseña',
        cuit: 'CUIT',
        datosincorrectos: 'Los datos ingresados son incorrectos.',
        usuarionopertenece: 'El usuario no pertenece a esta compañia',
        derechos: 'Todos los derechos reservados',
        descripcion: 'Descripción',
        direccion: 'Dirección',
        edicioncliente: 'Edición de Cliente',
        edicioninquilino: 'Edición de inquilino',
        edicionperfil: 'Edición de Perfil',
        edicionusuario: 'Edición de Usuario',
        editarinquilino: 'Editar inquilino',
        editarusuario: 'Editar usuario',
        editarperfil: 'Editar perfil',
        ejemploemail: 'ejemplo@email.com',
        email: 'Email',
        esquema: 'Esquema',
        guardar: 'Guardar',
        id: 'ID',
        inquilino: 'Inquilino',
        ingresar: 'Ingresar',
        loginbienvenido: 'Bienvenido',
        loginsubtitulo: 'Ingresa con tu usuario y contraseña.',
        loginoperacion: 'Operación',
        loginoverlaytexto: 'SAP B1 conectado a la operación diaria.',
        logincopyright: 'Copyright@ 2020 OilOne. Todos los derechos reservados',
        iniciosubtitulo: 'Módulos disponibles según el perfil del usuario.',
        inicioParteDescripcion: 'Registro de actividades en campo, carga móvil y transmisión de partes diarios.',
        inicioControlDescripcion: 'Documentación de recursos, alertas de vencimiento y habilitación para yacimientos.',
        inicioCheckDescripcion: 'Chequeos móviles de equipos, instalaciones y modelos configurables.',
        inicioMantenimientoDescripcion: 'Mantenimiento preventivo y correctivo, solicitudes, órdenes de trabajo e historial de equipos.',
        inicioGeneralDescripcion: 'Datos maestros y parámetros generales del sistema.',
        inicioBackofficeDescripcion: 'Inquilinos, usuarios, perfiles y seguridad del sistema.',
        configuracion: 'Configuración',
        configuracionadministracion: 'Configuración y administración',
        abrirpartediario: 'Abrir Parte Diario',
        abrircontroldocumental: 'Abrir Control Documental',
        abrirchecklist: 'Abrir Check List',
        abrirmantenimiento: 'Abrir Mantenimiento',
        abrirconfiguraciongeneral: 'Abrir Configuración General',
        abrirbackoffice: 'Abrir Backoffice',
        changepassSubtitulo: 'Actualiza tu clave de acceso para mantener protegida tu cuenta.',
        changepassFormularioTitulo: 'Nueva credencial',
        changepassFormularioTexto: 'Completa los campos para confirmar el cambio.',
        changepassClaveActual: 'Clave actual',
        changepassClaveActualPlaceholder: 'Ingresa tu clave actual',
        changepassClaveNueva: 'Clave nueva',
        changepassClaveNuevaPlaceholder: 'Ingresa la nueva clave',
        changepassRepetirClaveNueva: 'Reingresa la clave nueva',
        changepassRepetirClaveNuevaPlaceholder: 'Confirma la nueva clave',
        changepassNoCoinciden: 'Las claves nuevas no coinciden.',
        changepassCoinciden: 'Las claves nuevas coinciden.',
        changepassConsejosTitulo: 'Recomendaciones',
        changepassConsejoUno: 'Usa una clave distinta a las anteriores.',
        changepassConsejoDos: 'Combina letras, números y símbolos.',
        changepassConsejoTres: 'No compartas tu clave con otros usuarios.',
















        ingresarcontrasena: 'ingresar una contraseña...',
        ingresarcompania: 'ingresar una compañia...',
        ingresarcuit: 'ingresar el número de cuit',
        ingresardescripcion: 'ingresar una descripción...',
        ingresarrazonsocial: 'ingresar la razon social',
        ingresarnombre: 'insertar nombre ...',
        ingresarusuario: 'ingresar un usuario...',
        ingresarproximo: 'ingresar próximo número...',
        insertardireccion: 'insertar dirección...',
        insertarperfil: 'insertar perfil ...',
        listadoclientes: 'Listado de Clientes',
        listadoinquilinos: 'Listado de Inquilinos',
        listadoperfiles: 'Listado de Perfiles',
        listadousuarios: 'Listado de Usuarios',
        listadosegtareas: 'Listado de Tareas de Seguridad',
        nombre: 'Nombre',
        nuevocliente: 'Nuevo Cliente',
        nuevoinquilino: 'Nuevo Inquilino',
        nuevoperfil: 'Nuevo Perfil',
        nuevousuario: 'Nuevo Usuario',
        opciones: 'Opciones',
        perfil: 'Perfil',
        perfilsolopropio: 'Ver solo partes del usuario',
        razonsocial: 'Razón Social',
        seleccionarinquilino: 'Seleccionar inquilino ...',
        seleccionarperfil: 'seleccionar perfil ...',
        sistemaerp: 'Sistema ERP',
        tipo: 'Tipo',
        todosdatosrequeridos: 'Todos los campos son requeridos',
        usuario: 'Usuario',
        inicio: 'Inicio',
        cerrarsesion: 'Cerrar Sesión',
        inquilinos: 'Inquilinos',
        usuarios: 'Usuarios',
        clientes: 'Clientes',
        perfiles: 'Perfiles',
        editarcliente: 'Editar Cliente',
        nuevo: 'Nuevo',
        editar: 'Editar',
        minquilinos: 'Maestro de inquilinos',
        musuarios: 'Maestro de usuarios',
        mclientes: 'Maestro de clientes',
        mperfiles: 'Maestro de perfiles',
        msegtareas: 'Maestro de tareas de seguridad',
        modulos: 'Módulos',
        backoffice: 'Backoffice',
        partediario: 'Parte diario',
        controldocumental: 'Control documental',
        checklist: 'Check list',
        mantenimiento: 'Mantenimiento',
        general: 'General',
        abrirmenu: 'Abrir menú',
        buscaraccesos: 'Buscar accesos',
        buscaraccesosmenu: 'Buscar accesos en el menú',
        limpiarbusqueda: 'Limpiar búsqueda',
        sinaccesosbusqueda: 'No hay accesos disponibles para esta búsqueda.',
        sincronizadossapb1: 'Sincronizados con SAP B1',
        maestrosgenerales: 'Maestros Generales',
        operacion: 'Operación',
        reportes: 'Reportes',
        mgrupoarticulo: 'Maestro Grupo de Artículo',
        grupoarticulo: 'Grupo de Artículos',
        gruposarticulos: 'Grupos de Artículos',
        ediciongrupoarticulo: 'Edición de Grupo de Artículo',
        cargagrupoarticulo: 'Carga de Grupo de Artículo',
        insertargrupoarticulo: 'Ingresar una descripción de grupo de artículo',
        articulo: 'Artículo',
        articulos: 'Artículos',
        edicionarticulo: 'Edición de Artículo',
        cargaarticulo: 'Carga de Artículo',
        insertararticulo: 'Ingresar un artículo',
        marticulo: 'Maestro de Artículo',
        mtiposocionegocio: 'Maestro de Tipo Socio de Negocio',
        tiposocionegocio: 'Tipo Socio de Negocio',
        ediciontiposocionegocio: 'Edición de Tipo de Socio de Negocio',
        cargatiposocionegocio: 'Carga de Tipo de Socio de Negocio',
        msocionegocio: 'Maestro de Socio de Negocio',
        socionegocio: 'Socio de Negocio',
        sociosnegocio: 'Socios de Negocio',
        ingresaremail: 'Ingresar un email',
        seleccionartiposocionegocio: 'Seleccionar un tipo',
        cargasocionegocio: 'Carga de Socio de Negocio',
        edicionsocionegocio: 'Edición de Socio de Negocio',
        agregartiposocio: 'Agregar Tipo',
        mestadoempleado: 'Maestro de Estado de Empleado',
        estadoempleado: 'Estado de Empleado',
        edicionestadoempleado: 'Edición de Estado de Empleado',
        cargaestadoempleado: 'Carga de Estado de Empleado',
        insertarestadoempleado: 'Insertar un estado de emplado',
        empleado: 'Empleado',
        empleados: 'Empleados',
        estado: 'Estado',
        apellido: 'Apellido',
        telefono: 'Teléfono',
        costohoras: 'Costo horas',
        costohorasextra: 'Costo horas extras',
        mempleado: 'Maestro de Empleado',
        insertarempleado: 'Insertar Empleado',
        insertarnombre: 'Ingresar nombre',
        insertarapellido: 'Ingresar apellido',
        seleccionarcodigoestado: 'Seleccionar Estado',
        agregarestado: 'Agregar estado',
        ingresarcostohoras: 'Ingresar el costo por hora',
        ingresarcostohorasextra: 'Ingresar costo de horas extra',
        ingresartelefono: 'Ingresar un número de teléfono',
        edicionempleado: 'Edición de Empleado',
        cargaempleado: 'Carga de Empleado',
        seleccionarusuario: 'Seleccionar un usuario',
        agregarusuario: 'Agregar usuario',
        mubicacion: 'Maestro de Ubicación',
        ubicacion: 'Ubicación',
        edicionubicacion: 'Edición de Ubicación',
        cargaubicacion: 'Carga de Ubicación',
        ingresarubicacion: 'Ingresar una ubicación',
        msocionegocioubicacion: 'Maestro de Ubicación SN',
        socionegocioubicacion: 'Ubicación de Socio de Negocio',
        edicionsocionegocioubicacion: 'Edición de Ubicación del Socio de Negocio',
        cargasocionegocioubicacion: 'Carga de Ubicación del Socio de Negocio',
        seleccionarsocionegocio: 'Seleccionar un socio de negocio',
        seleccionarubicacion: 'Seleccionar una ubicación',
        agregarubicacion: 'Agregar ubicación',
        codigosocionegocio: 'Cod.SN',
        descripcionsocionegocio: 'Desc.SN',
        codigoubicacion: 'Cod.Ubicación',
        descripcionubicacion: 'Desc.Ubicación',
        mherramienta: 'Maestro de Herramientas',
        herramientas: 'Herramientas',
        edicionherramienta: 'Edición de Herramienta',
        cargaherramienta: 'Carga de Herramienta',
        ingresarherramienta: 'Ingresar herramienta',
        logooilone: 'Logo OilOne',
        seleccionaridioma: 'Seleccionar idioma',
        selecionaritem: 'Seleccionar un item de la lista',
        crearnuevo: 'Crear nuevo',
        ingresarcodigo: 'Ingresar código...',
        datosincompletos: 'Faltan datos por informar',

        logoeamone: 'Logo EAMOne',
        equipo: 'Equipo',
        fechaalta: 'Fecha alta',
        marca: 'Marca',
        modelo: 'Modelo',
        numeroserie: 'N°Serie',
        numerofabricacion: 'Nº Fabricación',
        largo: 'Largo',
        ancho: 'Ancho',
        alto: 'Alto',
        peso: 'Peso',
        responsable: 'Responsable',
        dominio: 'Dominio',
        cargaequipo: 'Carga de equipo',
        edicionequipo: 'Edición de equipo',
        mequipo: 'Maestro de Equipos',
        descripcionrequerida: 'La descripción es obligatoria',
        fecharequerida: 'La fecha es obligatoria',
        estadoequipo: 'Estado de equipo',
        estadoinicialequipo: 'Establecer estado inicial',
        equipopadre: 'Equipo padre',
        activofijo: 'Activo fijo',
        criticidad: 'Criticidad',
        mcriticidad: 'Maestro de Criticidad',
        volumen: 'Volumen',
        cargo: 'Posición',
        conductor: 'Conductor',
        tipoequipo: 'Tipo de equipo',
        mactivofijo: 'Maestro de Activo Fijo',
        mtipoequipo: 'Maestro de Tipos de Equipo',
        mestadoequipo: 'Maestro de Estados de Equipo',
        edicioncriticidad: 'Edición de criticidad',
        cargacriticidad: 'Carga de criticidad',
        edicionactivofijo: 'Edición de activo fijo',
        cargaactivofijo: 'Carga de activo fijo',
        ediciontipoequipo: 'Edición de tipo de equipo',
        cargatipoequipo: 'Carga de tipo de equipo',
        edicionestadoequipo: 'Edición de estado de equipo',
        cargaestadoequipo: 'Carga de estado de equipo',
        filtroequipo: 'Filtrar por equipo',
        padre: 'Padre',
        seleccionarpadre: 'Seleccionar un padre',
        errorobteniendodatos: 'Error al obtener los datos',
        nombres: 'Nombres',
        apellidos: 'Apellidos',
        seguroelimina: 'El ítem será eliminado ¿Está seguro?',
        mtipoempleado: 'Maestro de Tipos de Empleado',
        tipoempleado: 'Tipo de Empleado',
        tiposempleaso: 'Tipos de Empleado',
        ediciontipoempleado: 'Edición de Tipo de Empleado',
        cargatipoempleado: 'Carga de Tipo de Empleado',
        edicionsegtarea: 'Edición de Tarea de Seguridad',
        cargasegtarea: 'Carga de Tarea de Seguridad',
        textona: 'N/A',
        mtablas: 'Maestro de Tablas',
        tabla: 'Tabla',
        tablas: 'Tablas',
        seleccionartabla: 'Seleccionar una tabla',
        ediciontabla: 'Edición de Tabla',
        cargatabla: 'Carga de Tabla',
        tablagenericanoencontrada: 'Tabla No encontrada',
        valor: 'Valor',
        valores: 'Valores',
        dimensionescontables: 'Dimensiones contables',
        dimension: 'Dimensión',
        seleccionardimension: 'Seleccionar una dimensión',
        msyncprocesos: 'Registros de Sincronizaciones',
        syncproceso: 'Registro de Sincronización',
        numeroproceso: 'N° Proceso',
        tipoejecucion: 'Ejecución',
        withproblems: 'Con Problemas',
        ok: 'OK',
        manual: 'Manual',
        logdetalle: 'Detalles del Registro',
        logdocobjectcode: 'Código Objeto',
        cantprocesados: 'Cant. Procesados',
        cantsincronizados: 'Cant. Sincronizados',
        procesofinalizado: 'Proceso completado',
        procesofinalizadoconproblemas: 'Proceso completado con problemas',
        sinmodulosactivos: 'El inquilino no posee Módulos activos',

        importardatosmaestros: 'Importar Datos Maestros',
        formatonovalido: 'Formato no valido',
        arrastrarysoltarexel: 'Arraste y suelte un archivo Excel en este recuadro para procesarlo',
        importardatos: 'Importar',
        archivovalidado: 'Validado',
        archivovalido: 'Válido',
        archivonovalido: 'No válido',
        procesamientocorrecto: 'Procesamiento completado correctamente',
        procesamientocorrectoconproblemas: 'Procesamiento completado con problemas',
        inquilinotarget: 'Inquilino Destino',
        nombrearchivo: 'Nombre del Archivo',

        admin_abm: 'Administrar permisos e inquilinos',
        admin_abm_seg_tareas: 'Alta baja y modificacion de tareas',
        admin_seg_tarea_perfil: 'Administrar asignacion/desasignacion de tareas por perfil',
        admin_ver_seg_tareas: 'Ver listado de tareas',
        check_abm: 'Maestros de checklist',
        check_crear: 'Crear/Editar Checklist',
        check_ver: 'Ver Checklist',
        docu_abm: 'Maestros de documentación',
        docu_crear: 'Crear/Editar documentación',
        docu_ver: 'Ver documentación',
        general_abm: 'Maestros de datos del inquilino',
        mant_abm: 'Maestros de mantenimiento',
        mant_ver_medicion: 'Ver mediciones',
        mant_crear_medicion: 'Crear mediciones',
        mant_crear_ot: 'Crear/Editar OTs',
        mant_crear_sol: 'Crear/Editar solicitudes',
        mant_ver_ot: 'Ver OTs',
        mant_ver_estado: 'Gestión de mantenimientos',
        mant_ver_talleres: 'Ver talleres',
        mant_abm_talleres: 'Alta, baja y modificación de talleres',
        mant_st: 'Generar ST',
        mant_st_draft: 'Generar ST Preliminar',
        mant_sc: 'Generar SC',
        mant_sc_draft: 'Generar SC Preliminar',
        mant_ver_sol: 'Ver solicitues',
        mant_vista_plan: 'Vista planificación',
        mant_vista_seguim: 'Vista seguimiento',
        mant_vista_solic: 'Vista solicitante',
        parte_abm: 'Maestros de partes',
        parte_crear: 'Crear/Editar partes',
        parte_ver: 'Ver partes',
        solo_propio_parte: 'Ver solo partes del usuario',
        requieregeoreferencia: 'Registrar Geo-Referencia',

        upartone: 'PARTONE_Visible',
        ucheckone: 'CHECKONE_Visible',
        ueamone: 'EAMONE_Visible',
        udocuone: 'DOCUONE_Visible',
        mpartone: 'PARTONE',
        mcheckone: 'CHECKONE',
        meamone: 'EAMONE',
        mdocuone: 'DOCUONE',

        datorazonsocialyaregistrado: 'Razón Social ya registrada en otro Inquilino',
        nombreitemyaregistrado: 'Ya existe un item registrado con este nombre',

        /* ************************************************************************************************ */
        /* ***************************************** PARTE DIARIO ***************************************** */
        tareaparte: 'Tarea Parte Diario',
        mtarea: 'Maestro Tarea',
        ediciontareaparte: 'Edición de Tarea de Parte',
        cargatareaparte: 'Carga de Tarea de Parte',
        ingresartareaparte: 'Ingresar una tarea de parte',
        numeroparte: 'Parte N°',
        observaciones: 'Observaciones',
        cliente: 'Cliente',
        fecha: 'Fecha',
        hora: 'Hora',
        eliminar: 'Eliminar',
        observacionespublicas: 'Observaciones (públicas)',
        observacionesprivadas: 'Observaciones (privadas)',
        firmadigital: 'Firma',
        firmasdigitales: 'Firmas',
        comentarios: 'Comentarios',
        cargapartediario: 'Carga de Parte Diario',
        edicionpartediario: 'Edición de Parte Diario',
        agregarfila: 'Agregar una fila',
        agregartarea: 'Agregar tarea',
        descargar: 'Descargar',
        seleccionarfecha: 'Seleccionar una fecha',
        tarea: 'Tarea',
        tareas: 'Tareas',
        horainicio: 'Hora inicio',
        horafin: 'Hora fin',
        privado: 'Privado',
        facturable: 'Facturable',
        cantidadhoras: 'Cant.Horas',
        detallepartediario: 'Detalle de parte diario',
        cerrarparte: 'Cerrar parte',
        primerparte: 'Primer parte',
        parteanterior: 'Parte anterior',
        partesiquiente: 'Parte siguiente',
        ultimoparte: 'Último parte',
        detalle: 'Detalle',
        anexo: 'Adjuntos',
        arrastrarysoltar: 'Arraste y suelte archivos en este recuadro para subirlos',
        buscararchivos: 'Buscar archivos',
        campousuario: 'Campos de usuario',
        tamanio: 'Tamaño',
        obligatorio: 'Obligatorio',
        mcampousuario: 'Maestro Campo de Usuario',
        edicioncampousuario: 'Edición de campo de usuario',
        cargacampousuario: 'Carga de campo de usuario',
        nombrecampo: 'Nombre del Campo',
        tipocampo: 'Tipo de Campo',
        seleccionartipo: 'Seleccionar un tipo',
        cabecera: 'Cabecera',
        pie: 'Pie',
        ingresartamanio: 'Ingresar tamaño',
        tablerocontrol: 'Tablero de Control',
        modelosparte: 'Modelos de Parte Diario',
        modeloparte: 'Modelo de parte',
        composusuario: 'Campos de usuario',
        proximo: 'Próximo número',
        edicionmodelo: 'Edición de modelo de parte',
        cargamodelo: 'Carga de modelo de parte',
        nombrerequerido: 'El nombre es obligatorio',
        nuevocampo: 'Nuevo campo',
        campousuariodisponible: 'Campos de usuario disponibles',
        campousuarioseleccionado: 'Campos de usuario seleccionados',
        modelobase: 'Modelo base',
        comentarioscliente: 'Comentarios Cliente',
        errorguardar: 'Error al guardar los datos',
        partecerrado: 'Parte cerrado',
        georeferenciacion: 'Geo-Referencia',
        segurocerrar: 'El parte será cerrado ¿Está seguro?',
        cerrar: 'Cerrar',
        seleccionarmodelo: 'Seleccionar un modelo',
        grupocampousuario: 'Grupos de Campos de usuario',
        mgrupocampousuario: 'Maestro Grupos de Campos de Usuario',
        ediciongrupocampousuario: 'Edición de Grupo de campos de usuario',
        cargagrupocampousuario: 'Carga de Grupo de campos de usuario',
        nombregrupocampo: 'Nombre del Grupo',
        agruparen: 'Agrupar en',

        /* ************************************************************************************************ */
        /* ***************************************** CONTROL DOCUMENTAL ***************************************** */

        tipodocumentacion: 'Tipo de documentación',
        ediciontipodocumentacion: 'Edición de tipo de documentación',
        cargatipodocumentacion: 'Carga de tipo de documentación',
        documentacion: 'Documentación',
        mdocumentacion: 'Maestro de Documentación',
        mtipodocumentacion: 'Maestro de Tipo de Documentación',
        ediciondocumentacion: 'Edición de documentación',
        cargadocumentacion: 'Carga de documentación',
        tipodocumentacionrequerido: 'EL tipo de documentación es obligatorio',
        agregartipo: 'Agregar nuevo tipo',
        mrecursodocumentacion: 'Maestro de Documentación de Recursos',
        recursodocumentacion: 'Documentación de Recursos',
        tiporecurso: 'Tipo de recurso',
        vencimiento: 'Vencimiento',
        edicionrecursodocumentacion: 'Edición de documentación de recurso',
        cargarecursodocumentacion: 'Carga de documentación de recurso',
        selecionartiporecurso: 'Seleccionar un tipo de recurso',
        tiporecursorequerido: 'Tipo de recurso es obligatorio',
        selecionarrecurso: 'Seleccionar un recurso',
        recursorequerido: 'El recurso es obligatorio',
        documentacionrequerida: 'La documentación es obligatoria',
        recurso: 'Recurso',
        numerovigente: 'Número vigente',
        fechaemision: 'Emisión',
        fechaalerta: 'Alerta vencimiento',
        fechavencimiento: 'Vencimiento',
        costo: 'Costo',
        agregarrecurso: 'Agregar un recurso',
        nueva: 'Nueva',
        msocionegociodocumentacion: 'Maestro de Documentación Socio Negocio',
        socionegociodocumentacion: 'Documentación Socio Negocio',
        inhabilita: 'Inhabilita',
        edicionsocionegociodocumentacion: 'Edición de documentación de socio de negocio',
        cargasocionegociodocumentacion: 'Carga de documentación de socio de negocio',
        si: 'Si',
        no: 'No',
        posicion: 'Posición',
        seleccionarposicion: 'Seleccionar una posición',
        activo: 'Activo',
        inactivo: 'Inactivo',
        documentacionnovigente: 'No vigente',
        documentacionvigente: 'Vigente',
        documentacionporvencer: 'Doc. por vencer',
        documentacionvencida: 'Doc.Vencida',

        /* ************************************************************************************************ */
        /* ***************************************** CHECK LIST***************************************** */
        mmodelochecklist: 'Maestro de Modelo Checklist',
        mcomponentecheck: 'Maestro de Componente Checklist',
        componentecheck: 'Componente de checklist',
        cargacomponentecheck: 'Carga de Componente de Checklist',
        edicioncomponentecheck: 'Edición de Componente de Cheklist',
        mtiporecurso: 'Maestro de Tipo de Recurso',
        ediciontiporecurso: 'Edición del Tipo de Recurso',
        cargatiporecurso: 'Carga del Tipo de Recurso',
        recursos: 'Recursos',
        campos: 'Campos',
        cargamodelocheck: 'Carga de Modelo de Checklist',
        edicionmodelocheck: 'Edición de Modelo de Checklist',
        recursosdisponibles: 'Recursos disponibles',
        recursosseleccionados: 'Recursos seleccionados',
        seleccionartodos: 'Seleccionar todos',
        eliminartodos: 'Eliminar todos',
        camposdisponibles: 'Campos disponibles',
        camposseleccionados: 'Campos seleccionados',
        usuariosdisponibles: 'Usuarios disponibles',
        usuariosseleccionados: 'Usuarios seleccionados',
        modeloscheck: 'Modelos de Checklist',
        edicionchecklist: 'Edición de Checklist',
        cargachecklist: 'Carga de Checklist',
        detallechecklist: 'Detalle de Checklist',
        numerocheck: 'N° Checklist',


        noeditaelemento: 'No es posible editar este elemento',
        elementoguardado: 'Elemento guardado con éxito',
        componentesdisponibles: 'Componentes Disponibles',
        componentes: 'Componentes',
        asociarrecursos: 'Asociar a Recursos',
        asociarusuarios: 'Asociar a Usuarios',


        /********************************************************************************************************************************** */
        /*************** MANTENIMIENTO********************************************************************************************* */

        articuloprevisto: 'Artículo Previsto',
        articulosprevistos: 'Artículos Previstos',
        marticuloprevisto: 'Maestro de Artículo Previsto',
        edicionarticuloprevisto: 'Edición de Artículo Previsto',
        cargaarticuloprevisto: 'Carga de Artículo Previsto',
        mrrhhprevisto: 'Maestro de recursos humanos previstos',
        rrhhprevisto: 'Recurso humano previsto',
        rrhhsprevistos: 'Recursos humanos previstos',
        edicionrrhhprevisto: 'Edición de Recurso Humano Previsto',
        cargarrhhprevisto: 'Carga de Recurso Humano Previsto',
        mtareaprevista: 'Maestro de Tareas Previstas',
        ediciontareaprevista: 'Edición de Tarea Prevista',
        cargatareaprevista: 'Carga de Tarea Prevista',
        tareaprevista: 'Tarea Prevista',
        tareasprevistas: 'Tareas Previstas',
        mtiporesultado: 'Maestro de Tipos de Resultado',
        tiporesultado: 'Tipo de Resultado',
        tiposresultado: 'Tipos de Resultado',
        ediciontiporesultado: 'Edición de Tipos de Resultado',
        cargatiporesultado: 'Carga de Tipos de Resultado',
        mtipofrecuencia: 'Maestro de Tipos de Frecuencia',
        tipofrecuencia: 'Tipo de Frecuencia',
        tiposfrecuencia: 'Tipos de Frecuencia',
        tiposmedicion: 'Tipos de Medición',
        ediciontipofrecuencia: 'Edición de Tipo de Frecuencia',
        cargatipofrecuencia: 'Carga de Tipo de Frecuencia',
        mestadoot: 'Maestro de Estados de Ordenes de Trabajo',
        estadoot: 'Estados de Ordenes de Trabajo',
        edicionestadoot: 'Edición de Estado de Orden de Trabajo',
        cargaestadoot: 'Carga de Estado de Orden de Trabajo',
        msolicitante: 'Maestro de Solicitantes',
        solicitante: 'Solicitante',
        solicitantes: 'Solicitantes',
        edicionsolicitante: 'Edición de Solicitante',
        cargasolicitante: 'Carga de Solicitante',
        mprioridad: 'Maestro de Prioridades',
        prioridad: 'Prioridad',
        prioridades: 'Prioridades',
        edicionpriodidad: 'Edición de Prioridad',
        cargaprioridad: 'Carga de Prioridad',
        mestadosolicitud: 'Maestro de Estados de Solicitud',
        estadosolicitud: 'Estados de Solicitud',
        edicionestadosolicitud: 'Edición de Estado de Solicitud',
        cargaestadosolicitud: 'Carga de Estado de Solicitud',
        generasolicitud: 'Genera Solicitud',
        generasolicitudobservaciones: 'Explicación',
        generasolicitudlimite: 'Límite a superar',
        generasolicitudvalor: 'Valor actual',
        mtipomantenimiento: 'Maestro de Tipos de Mantenimiento',
        mtipomedicion: 'Maestro de Tipos de Medicion',
        mtalleres: 'Maestro de Talleres',
        taller: 'Taller',
        talleres: 'Talleres',
        cargataller: 'Carga de Taller',
        ediciontaller: 'Edición de Taller',
        asignarusuariosataller: 'Asignar usuarios al taller',
        tipomantenimiento: 'Tipos de Mantenimiento',
        ediciontipomantenimiento: 'Edición de Tipo de Mantenimiento',
        cargatipomantenimiento: 'Carga de Tipo de Mantenimiento',
        ediciontarea: 'Edición de Tarea',
        cargatarea: 'Carga de Tarea',
        selecionartiporesultado: 'Seleccionar tipo de resultado',
        msolicitudmantenimiento: 'Maestro de Solicitudes de Mantenimiento',
        solicitudmantenimiento: 'Solicitud de Mantenimiento',
        solicitudesmantenimiento: 'Solicitudes de Mantenimiento',
        seguimientosolicitudesmantenimiento: 'Seguimiento de Solicitudes de Mantenimiento',
        planificacion: 'Planificación',
        edicionsolicitudmantenimiento: 'Edición de Solicitudes de Mantenimiento',
        cargasolicitudmantenimiento: 'Carga de Solicitudes de Mantenimiento',
        numero: 'Número',
        numeroot: 'N° OT',
        ordentrabajo: 'Orden de Trabajo',
        codigoequipo: 'Cod. Equipo',
        descripcionequipo: 'Desc. Equipo',
        plan: 'Plan',
        nombreplan: 'Nombre plan',
        crearot: 'Crear OT',
        ignorar: 'Ignorar',
        seguroignorar: 'Esto va a IGNORAR la solicitud. ¿Está seguro?',
        segurocancelar: 'Esto va a CANCELAR la solicitud. ¿Está seguro?',
        mordenestrabajo: 'Maestro de Órdenes de Trabajo',
        ordenestrabajo: 'Órdenes de Trabajo',
        segurocancelarot: 'Esto va a CANCELAR la OT. ¿Está seguro?',
        segurofinalizarot: 'Esto va a FINALIZAR la OT. ¿Está seguro?',
        edicionordentrabajo: 'Edición de Orden de Trabajo',
        cargaordentrabajo: 'Carga de Orden de Trabajo',
        solicitud: 'Solicitud',
        descripcionactivofijo: 'Desc.Activo Fijo',
        codigotarea: 'Cod. Tarea',
        descripciontarea: 'Desc. Tarea',
        descripciontiporesultado: 'Desc. Tipo Resultado',
        check: 'Check',
        resultado: 'Resultado',
        fechainicio: 'Fecha Inicio',
        fechafin: 'Fecha Fin',
        ejecutante: 'Ejecutante',
        observacion: 'Observación',
        rrhhprev: 'RRHH Prev.',
        descripciontiporecurso: 'Desc. Tipo Recurso',
        horasprevistas: 'Horas previstas',
        articulosprev: 'Artículos Prev.',
        articulosreq: 'Artículos Req.',
        cantidad: 'Cantidad',
        tipomedicion: 'Tipo Medición',
        valormedicion: 'Valor Medición',
        fechamedicion: 'Fecha Medición',
        usuariomedicion: 'Usuario Medición',
        contadores: 'Contadores',
        motivo: 'Motivo',
        mediciones: 'Mediciones',
        crearmedicion: 'Nueva Medición',
        edicionmedicion: 'Editar Medición',
        medicion: 'Medición',
        planmantenimiento: 'Plan de Mantenimiento',
        planesmantenimiento: 'Planes de Mantenimiento',
        edicionplanmantenimiento: 'Edición de Planes de Mantenimiento',
        cargaplanmantenimiento: 'Carga de Plan de Mantenimiento',
        frecuencia: 'Frecuencia',
        equiposdisponibles: 'Equipos disponibles',
        equiposseleccionados: 'Equipos seleccionados',
        asignarplanaequipos: 'Asignar plan a equipos',
        codequipo: 'Cod.Equipo',
        tiposrrhhprevisto: 'Tipos de RRHH Previstos',
        tiporrhhprevisto: 'Tipo de RRHH Previsto',
        mtiposrrhhprevisto: 'Maestro de Tipos de RRHH Previstos',
        ediciontiporrhhprevisto: 'Edición de Tipo de RRHH Previsto',
        cargatiporrhhprevisto: 'Carga de Tipo de RRHH Previsto',
        nombreejecutante: 'Nombre Ejecutante',
        algoritmo: 'Genera Solicitudes de Mantenimiento',
        vertodas: 'Ver Todas',
        descargaarchivoexcel: 'Exportar a Excel',
        actualizar: 'Actualizar',
        costomantenimiento: 'Costos de Mantenimiento',
        costos: 'Costos',
        disponibilidadequipos: 'Disponibilidad de Equipos',
        codigoestado: 'Cod.Estado',
        descripcionestado: 'Descripción Estado',
        nombreestado: 'Estado',
        informeequipos:'Reporte de Equipos',
        reportecostomantenimiento: 'Reporte costo mantenimiento',
        reportehistorialubicacion: 'Reporte Historial de Ubicación',
        reporteequipos: 'Reporte de Equipos',
        reportedisponibilidadequipos: 'Reporte Disponibilidad de Equipos',
        reportetareaspendientes: 'Reporte de Tareas pendientes',
        nombreubicacion: 'Ubicación',
        nombresocionegocio: 'Socio Negocio',
        nombretiposocionegocio: 'Tipo Socio Negocio',
        reporteordentrabajo: 'Reporte de Ordenes de Trabajo',
        codigotipomantenimiento: 'Cod.Tipo Mant.',
        codigousuario: 'Cod.Usuario',
        codigoprioridad: 'Cod.Prioridad',
        numerosolicitud: 'Nro. Solicitud',
        fechasolicitud: 'Fecha Solicitud',
        codigoplanmantenimiento: 'Cod.Plan de Mant.',
        descripcionplanmantenimiento: 'Desc.Plan de Mant.',
        codigoempleado: 'Cod Empleado',
        nombresempleado: 'Nombre Empleado',
        apellidosempleado: 'Apellido Empleado',
        nombrecompletoempleado: 'Nombre y Apellido del Empleado',
        stock: 'Stock',
        sindatos: 'Sin datos',
        pedir: 'Pedir',
        asolicitar: 'A solicitar',
        resultadosincronizacion: 'Resultado Sincronización',
        sinmensaje: 'Sin mensaje',
        consulteresgistrosync: 'Consulte el Registro de sincronizaciones',
        syncexitosa: 'Sincronización exitosa',
        syncfinalizadoconproblemas: 'Sincronización completada con problemas',
        errorsincronizacion: 'Error en Sincronización',
        huboerrorsincronizar: 'Hubo un error al sincronizar',
        errorcrearsyncproceso: 'Error al crear el proceso',
        sistemanosoportado: 'Sistema no soportado',
        inquilinonoencontrado: 'Inquilino no encontrado',
        errorvalidacionparametrossap: 'No se rebasaron las validaciones de Parámetros de SAP',
        sincronizarmaestros: 'Sincronizar maestros',
        cambiarclave: 'Cambiar clave',
        tiposempleado: 'Tipos de empleado',
        partesenestadocreado: 'Partes en estado "creado"',
        partesporclientemesactual: 'Partes por Cliente (Mes Actual)',
        partesporubicacionmesactual: 'Partes por Ubicación (Mes Actual)',
        partespormodelomesactual: 'Partes por Modelo (Mes Actual)',
        partescerradosvscreados: 'Partes Cerrados vs Creados',
        demoracierreporusuario: 'Demora de cierre por Usuario',
        sinelementos: 'Sin elementos',
        diasdedemora: 'Días de demora',
        creados: 'Creados',
        cerrados: 'Cerrados',
        unidades: 'unidades',
        cantidadtotalcheck: 'Cantidad total de checklist',
        cantidadtotalcheckmesactual: 'Cantidad de checklist (Mes Actual)',
        otscreadas: 'OTs Creadas',
        otsplanificadas: 'OTs Planificadas',
        otsejecutadas: 'OTs Ejecutadas',
        tareaspendientes: 'Tareas pendientes',
        equiposfueradeservicio: 'Equipos Fuera de Servicio',
        costototalmantenimiento: 'Costo Total de Mantenimiento',
        correctivovspreventivo: 'Correctivo vs Preventivo',
        costomantenimientoporequipo: 'Costo de Mantenimiento por Equipo',
        historialot: 'Historial de OTs',
        unicoejecutante: 'Ejecutante único',
        datosunicos: 'Datos únicos',
        docscprelim: 'Solicitud de Compras',
        docstprelim: 'Solicitud al Almacén',
        docsc: 'Solicitud de Compras',
        docst: 'Solicitud al Almacen',
        finalizarot: 'Finalizar OT',
        obtenerstockSAP: 'Recuperar datos de stock desde SAP',
        operacionexitosa: 'Operación realizada con éxito',
        tiposolicitudb1invalido: 'Tipo solicitud inválido',
        otnoencontrada: 'OT No encontrada',
        usuarionoencontrado: 'No se encontró el usuario.',
        fallologinremoto: 'Falló login remoto',
        fallocreardraft: 'Falló crear draft',
        errorenconexionServiceLayer: 'Hubo un error al conectar a Service Layer',
        itemnoencontrado: 'Item no encontrado',
        itemalreadyunsubscribe: 'El item ya se encuentra dado de baja',
        generar: 'Generar',
        otsolplansincontadores: 'La OT proviene de una solicitud autogenerada, pero no tiene valor de contador nuevo',
        otdatosunicosnouniformes: 'Con datos únicos habilitado, todas las tareas deben tener el mismo ejecutante y la misma fecha y hora de inicio y fin. Use los campos de "Datos únicos" para unificarlos.',
        medicionnoencontrada: 'Tipo de medición no encontrado',
        medicionmanual: 'No se puede ingresar manualmente una medición de fecha',
        medicioninferior: 'No se puede ingresar una medición inferior a una anterior',
        medicionsuperior: 'No se puede ingresar una medición superior a una posterior',
        medicionequiponoencontrado: 'No se puede ingresar mediciones a Equipos inexistente o inactivos',
        porcetajeotxtipomtto: '% de OT por Tipo Mantenimiento',

        deleteviolation: 'No se puede eliminar porque está siendo utilizado',
        updateviolation: 'No se puede actualizar porque está siendo utilizado',
        planmantenimientonoencontrado: 'Plan de Mantenimiento No encontrado',
        equiponoencontradooinactivo: 'Equipo No encontrado o Inactivo',
        prioridadnoencontradooinactiva: 'Tipo de Prioridad No encontrado o Inactivo',
        tipomttonoencontradooinactivo: 'Tipo de Mantenimiento No encontrado o Inactivo',
        tallernoencontradoobaja: 'El taller seleccionado no existe o fue dado de baja',
        tallerinactivo: 'No se puede asignar un taller inactivo',
        tallernoseleccionable: 'No disponible para seleccionar',
        tallernoperteneceusuario: 'El taller seleccionado no pertenece al usuario',
        sinpermisomodtallersolicitud: 'No tiene permiso para modificar el taller de la solicitud',
        sinpermisomodtallerot: 'No tiene permiso para modificar el taller de la OT',

        cantsc: 'Cant. Solic. Compras',
        cantst: 'Cant. Solic. Almacén',
        articulonoencontradooinactivo: 'Artículo(s) no encontrado(s) o inactivo(s). Código(s): ',
        valorexcedemax: 'El valor ingresado excede el máximo permitido',
        articulosrepetidos: 'Existen artículos repetidos',
        fechaubicacion: "Fecha Asignación Ubicación",
        exito: "Éxito",
        errorfechaubicacion: "La fecha de asignación ubicación no puede ser menor a la última fecha cargada",
        errorguardararticulos: 'Error al guardar los artículos',
        errorguardararticuloporduplicado: 'Artículos duplicados. Si desea modificar la cantidad, hágalo directamente sobre el artículo ya cargado.',
        tipomantnoencontrado: "Tipo mantenimiento no encontrado",
        priotidadnoencontrada: "Prioridad no encontrada",
        estadosolnoencontrado: "Estado de solicitud no encontrado",
        errorvalidarparametros: "Error al validar parámetros",
        soloarchivospng: "Solo se permiten archivos en formato PNG",
        nofile: "Adjunto no encontrado",
        s3filenotfound: "Ocurrió un error al intentar recuperar el archivo",
        inquilinosinlogo: "No se encontró el logo del inquilino. Se utilizará el logo por defecto.",
        numerodocumento: 'Nro. de Doc.',
        fechadocumento: 'Fecha de Doc.',
        nombrecompleto: 'Nombre Completo',
        codigoarticulo: 'Cod. Artículo',
        descripcionarticulo: 'Desc. Artículo',
        pagina: 'Página',
        de: 'De',
        reportehistorialestadoequipo: 'Reporte Historial de Estado de Equipos',
        historialestadoequipo: 'Historial de Estado de Equipos',
        fechaestado: "Fecha Asignación Estado",
        formatoinvalido: 'Formato inválido. Permitidos: {ext}',
        aclaracion: "Aclaración",
        mparametrosgenerales: "Maestro de Parámetros Generales por módulos del Sistema",
        tablagenerica: "Tabla Genérica",
        texto: "Texto",
        parametrogeneral: "Parámetro General",
        parammodsistemanoencontrado: "Parámetro módulo Sistema No Encontrado",
        modulo: "Módulo",
        parametrosgenerales: "Parámetros Generales",
        registrosyscoreerror: "Los registros internos del sistema (SYSCORE) no pueden ser modificados.",
        errorvalidacionparametros: 'No se rebasaron las validaciones de Parámetros',
        errorconfigtablausuarioeamone: 'No se configuró correctamente la tabla de usuario en EamOne.',
        errorinsertarequiposap: 'Error al insertar equipo en SAP',
        errortablausuariosap: 'Verifica que la tabla de usuario exista en SAP y tenga todas las columnas.',
        notienepermiso: "No tiene permiso para completar la acción",
        gestionmantenimientos: 'Gestión de mantenimientos',
        estadoinicial: 'Estado inicial',
        yaexisteunestadoinicial: 'Ya existe un estado de ot marcado como estado inicial',
        restriccionestadoinicialinactivo: 'No es posible marcar como inactivo un estado inicial',
        historialestadoot: 'Historial Estado de OTs',
        mtranestadosot: 'Maestro de Transiciones de Estados de Órdenes de Trabajo',
        estadoorigen: 'Estado origen',
        estadodestino: 'Estado destino',
        tipoasignacion: 'Tipo de asignación',
        editable: 'Editable',
        noencontrado: 'Registro no encontrado',
        transicionestadoot: 'Transiciones de Estado de Órdenes de Trabajo',
        ediciontransicionestadoot: 'Editar la transición de estado',
        cargatransicionestadoot: 'Cargar la transición de estado',
        elregistroyaexiste: 'El registro ya existe',
        errordestinoestadoinicial: 'El estado destino no puede ser inicial',
        estadoorigennovalido: 'Debe informar un estado de origen válido.',
        estadodestinonovalido: 'Debe informar un estado de destino válido.',
        estadoorigenigualestadodestino: 'El estado de origen no puede ser el mismo que el estado destino',
        nosepuedeeditar: 'Este registro no puede ser editado',
        nosepuedeeliminar: 'Este registro no puede ser eliminado',
        perfilesinvalidos: 'El campo perfiles es inválido.',
        usuariosinvalidos: 'El campo usuarios es inválido.',
        perfilousuariorequerido: 'Debe seleccionar al menos un perfil o usuario.',
        perfilesautorizados: 'Perfiles Autorizados',
        usuariosautorizados: 'Usuarios Autorizados',
        errortareaseguridad: 'No fue posible generar la tarea de seguridad para la transición.',
        registrosystemcore: 'Este registro no puede ser editado porque pertenece al sistema',
        elimregistrosystemcore: 'Este registro no puede ser eliminado porque pertenece al sistema',
        cuidado: '¡Cuidado!',
        importante: 'Importante',
        apikeydadadebaja: 'Esta Api Key se encuentra dada de baja.',
        UniqueUsuarioFechaModeloViolation: "No se puede crear o modificar con los parámetros indicados porque ya existe otro igual",
        SequelizeForeignKeyConstraintError: "No se puede realizar la operación porque está siendo utilizado",
        SequelizeUniqueConstraintError: "No se puede realizar la operación porque ya existe un dato con el valor ingresado",
        ExecConstraints: "No se puede realizar la operación porque no cumplen las restricciones",
        valuemustnotbenegative: "El campo valor no puede ser un número negativo",
        equiposintipomedicionerror: "No se puede ingresar mediciones a Equipos que no poseen tipo de mediciones",
        tipomedicionnoasociadoalequipo: "El tipo de medicion no está asociado al equipo",
        valuetoolong: "El valor ingresado es demasiado largo",
        valueoutofrange: "El valor está fuera del rango permitido",
        versolicitud: "Ver solicitud",
        tituloasunto: "Título Solicitud",
        observacionot: "Observación OT",
        codigoitemyaregistrado: 'Ya existe un item registrado con este código.',
        estadootnoencontrado: 'Estado de OT no encontrado.',
        errorbajaestadoot: 'Error al dar de baja el estado de OT.',
        errorbajatransicionestadoot: 'Error al dar de baja la transición de estado de OT.',
        operacionnopermitidaporestadoot: 'No se puede realizar la operación por el estado de la OT',
        loginintegradocon: 'Integrado con',
        usardatosunicos: 'Usar datos únicos (ejecutante y fecha/hora comunes a todas las tareas)',
        fechainicioot: 'Fecha Inicio OT',
        horainicioot: 'Hora Inicio OT',
        fechafinalizacioncomprometida: 'Fecha Fin Comprometida',
        horafinalizacioncomprometida: 'Hora Fin Comprometida',
        fechafinantesinicio: 'La fecha y hora de finalización comprometida no puede ser anterior a la fecha y hora de inicio.',
        fechahorainicioot: 'Fecha y hora inicio de planificación',
        fechahorafinot: 'Fecha y hora fin de planificación',
        ordenar: 'Ordenar',
        ordenarpor: 'Ordenar por',
        direccionorden: 'Dirección',
        ascendente: 'Ascendente',
        descendente: 'Descendente',
        seleccionecolumna: 'Seleccione una columna',
        primera: 'Primera',
        anterior: 'Anterior',
        siguiente: 'Siguiente',
        ultima: 'Última',
        mostrar: 'Mostrar',
        registros: 'registros',
        sincoincidencias: 'No se encontraron coincidencias en los registros cargados',
        pruebebusquedaavanzada: 'Pruebe la búsqueda avanzada',
        restablecer: 'Restablecer',
        restablecervista: 'Quitar filtros y orden',
        sinresultadosbusqueda: 'La búsqueda no encontró ningún registro',
        busquedaavanzada: 'Búsqueda avanzada',
        limpiar: 'Limpiar',
        todos: 'Todos',
        mprogramacionesprocesos: 'Programaciones de ejecución automática',
        proceso: 'Proceso',
        diassemana: 'Días de la semana',
        horario: 'Horario',
        domingo: 'Domingo',
        lunes: 'Lunes',
        martes: 'Martes',
        miercoles: 'Miércoles',
        jueves: 'Jueves',
        viernes: 'Viernes',
        sabado: 'Sábado',
        cargaprogramacionproceso: 'Carga de Programación de ejecución automática',
        edicionprogramacionproceso: 'Edición de Programación de ejecución automática',
        frecuenciainvalida: 'La frecuencia informada no es válida',
        procesonoencontrado: 'Proceso no encontrado o inactivo',
        auto: 'Automática',
        codigoprogramacionexistente: 'Ya existe una programación con el código ingresado',
        fechaot: 'Fecha de OT',
        fechainicioejecucion: 'Fecha inicio ejecución',
        fechafinejecucion: 'Fecha fin ejecución',
        horainicioejecucion: 'Hora inicio ejecución',
        horafinejecucion: 'Hora fin ejecución',
        sinpermisoeditarfechasot: 'No tiene permiso para cargar o modificar las fechas de planificación de la OT',
        sinarticulossolicitud: 'Seleccione al menos un artículo con cantidad pendiente para generar la solicitud',
        articulonopendienteot: 'Solo se pueden solicitar artículos de la OT, sin superar la cantidad pendiente',
    },
    en: {
      otscreadas: 'Created WO',
      otsplanificadas: 'Planned WO',
      otsejecutadas: 'Executed WO',
      tareaspendientes: 'Pending Tasks',
      equiposfueradeservicio: 'Out of Service Equipment',
      costototalmantenimiento: 'Total Maintenance Cost',
      correctivovspreventivo: 'Corrective vs Preventive',
      costomantenimientoporequipo: 'Equipment Maintenance Cost',
      cantidadtotalcheckmesactual: 'Checklist total quantity (Current Month)',
      cantidadtotalcheck: 'Checklist total quantity',
      unidades: 'units',
      cerrados: 'Closed',
      creados: 'Created',
      diasdedemora: 'Delay days',
      sinelementos: 'Without elements',
      demoracierreporusuario: 'Closing by User Delay',
      partescerradosvscreados: 'Closed vs Created Reports',
      partespormodelomesactual: 'Reports by Model (Current Month)',
      partesporubicacionmesactual: 'Reports by Location (Current Month)',
      partesporclientemesactual: 'Reports by Customer (Current Month)',
      partesenestadocreado: 'Reports on Created status ',
      tiposempleado: 'Employee types',
      cambiarclave: 'Password change',
      sincronizarmaestros: 'Masters sync',
        buscar: 'Search',
        cargando: 'Loading...',
        formatofecha: 'MM-dd-yyyy',
        aceptar: 'Accept',
        filtrar: 'Filter',
        vistaimpresion: 'Print preview',
        basedatos: 'Data base',
        borrar: 'Delete',
        borrarinquilino: 'Delete tenant',
        borrarperfil: 'Delete profile',
        borrarusuario: 'User delete',
        cancelar: 'Cancel',
        cargacliente: 'Client loading',
        cargainquilino: 'Tenant loading',
        cargaperfil: 'Profile loading',
        cargausuario: 'User loading',
        codigo: 'Code',
        compania: 'Company',
        contrasena: 'Password',
        cuit: 'CUIT',
        datosincorrectos: 'Entered information is not correct.',
        usuarionopertenece: 'The user doesn\'t belong to this company',
        derechos: 'All right reserved',
        descripcion: 'Description',
        direccion: 'Address',
        edicioncliente: 'Client edition',
        edicioninquilino: 'Tenant editing',
        edicionperfil: 'Profile editing',
        edicionusuario: 'User editing',
        editarinquilino: 'Tenant edit',
        editarusuario: 'User edition',
        editarperfil: 'Edit profile',
        ejemploemail: 'example@email.com',
        email: 'Email',
        esquema: 'Schema',
        guardar: 'Save',
        id: 'ID',
        inquilino: 'Tenant',
        ingresar: 'Login',
        loginbienvenido: 'Welcome',
        loginsubtitulo: 'Sign in with your username and password.',
        loginoperacion: 'Operations',
        loginoverlaytexto: 'SAP B1 connected to daily operations.',
        logincopyright: 'Copyright@ 2020 OilOne. All rights reserved',
        iniciosubtitulo: 'Available modules according to the user profile.',
        inicioParteDescripcion: 'Field activity records, mobile entry, and daily report transmission.',
        inicioControlDescripcion: 'Resource documentation, expiration alerts, and site access enablement.',
        inicioCheckDescripcion: 'Mobile checks for equipment, facilities, and configurable models.',
        inicioMantenimientoDescripcion: 'Preventive and corrective maintenance, requests, work orders, and equipment history.',
        inicioGeneralDescripcion: 'Master data and general system parameters.',
        inicioBackofficeDescripcion: 'Tenants, users, profiles, and system security.',
        configuracion: 'Configuration',
        configuracionadministracion: 'Configuration and administration',
        abrirpartediario: 'Open Daily Report',
        abrircontroldocumental: 'Open Document Control',
        abrirchecklist: 'Open Check List',
        abrirmantenimiento: 'Open Maintenance',
        abrirconfiguraciongeneral: 'Open General Configuration',
        abrirbackoffice: 'Open Backoffice',
        changepassSubtitulo: 'Update your access password to keep your account protected.',
        changepassFormularioTitulo: 'New credential',
        changepassFormularioTexto: 'Complete the fields to confirm the change.',
        changepassClaveActual: 'Current password',
        changepassClaveActualPlaceholder: 'Enter your current password',
        changepassClaveNueva: 'New password',
        changepassClaveNuevaPlaceholder: 'Enter the new password',
        changepassRepetirClaveNueva: 'Re-enter the new password',
        changepassRepetirClaveNuevaPlaceholder: 'Confirm the new password',
        changepassNoCoinciden: 'The new passwords do not match.',
        changepassCoinciden: 'The new passwords match.',
        changepassConsejosTitulo: 'Recommendations',
        changepassConsejoUno: 'Use a password different from previous ones.',
        changepassConsejoDos: 'Combine letters, numbers, and symbols.',
        changepassConsejoTres: 'Do not share your password with other users.',
















        ingresarcontrasena: 'enter a password...',
        ingresarcompania: 'insert a company...',
        ingresarcuit: 'insert the cuit number',
        ingresardescripcion: 'insert a description...',
        ingresarrazonsocial: 'insert the company name',
        ingresarnombre: 'insert name ...',
        ingresarusuario: 'insert an user...',
        ingresarproximo: 'fill next number...',
        insertardireccion: 'insert an address',
        insertarperfil: 'insert profile ...',
        listadoclientes: 'Clients listing',
        listadoinquilinos: 'Tenants listing',
        listadoperfiles: 'Profile listing',
        listadousuarios: 'User listing',
        listadosegtareas: 'Security Taks listing',
        nombre: 'Name',
        nuevocliente: 'New Client',
        nuevoinquilino: 'New Tenant',
        nuevoperfil: 'New Profile',
        nuevousuario: 'New User',
        opciones: 'Options',
        perfil: 'Profile',
        perfilsolopropio: 'Only own daily report',
        razonsocial: 'Company Name',
        seleccionarinquilino: 'select a tenant ...',
        seleccionarperfil: 'select a profile ...',
        sistemaerp: 'ERP System',
        tipo: 'Type',
        todosdatosrequeridos: 'All the camps are required',
        usuario: 'User',
        inicio: 'Home',
        cerrarsesion: 'Logout',
        inquilinos: 'Tenants',
        usuarios: 'Users',
        clientes: 'Clients',
        perfiles: 'Profiles',
        editarcliente: 'Client edit',
        nuevo: 'New',
        editar: 'Edit',
        minquilinos: 'Tenants master',
        musuarios: 'Users master',
        mclientes: 'Clients master',
        mperfiles: 'Profiles master',
        msegtareas: 'Security taks master',
        modulos: 'Modules',
        backoffice: 'Backoffice',
        partediario: 'Daily report',
        controldocumental: 'Documental control ',
        checklist: 'Check list',
        mantenimiento: 'Maintenance',
        general: 'General',
        abrirmenu: 'Open menu',
        buscaraccesos: 'Search menu items',
        buscaraccesosmenu: 'Search menu items',
        limpiarbusqueda: 'Clear search',
        sinaccesosbusqueda: 'No available items for this search.',
        sincronizadossapb1: 'Synced with SAP B1',
        maestrosgenerales: 'General Masters',
        operacion: 'Operation',
        reportes: 'Reports',
        mgrupoarticulo: 'Article Group Master',
        grupoarticulo: 'Articles Group',
        gruposarticulos: 'Articles Groups',
        ediciongrupoarticulo: 'Article Group Edition',
        cargagrupoarticulo: 'Article Group Creation',
        insertargrupoarticulo: 'Insert an article group description',
        articulo: 'Article',
        articulos: 'Articles',
        edicionarticulo: 'Article Edition',
        cargaarticulo: 'Article Creation',
        insertararticulo: 'Insert an article',
        marticulo: 'Article Master',
        mtiposocionegocio: 'Business Partner Type Master',
        tiposocionegocio: 'Business Partner Type',
        ediciontiposocionegocio: 'Business Partner Type Edition',
        cargatiposocionegocio: 'Business Partner Type Creation',
        msocionegocio: 'Business Partner Master',
        sociosnegocio: 'Business Partners',
        socionegocio: 'Business Partner',
        ingresaremail: 'Insert an email',
        seleccionartiposocionegocio: 'Select a type',
        cargasocionegocio: 'Business Partner Creation',
        edicionsocionegocio: 'Business Partner Edition',
        agregartiposocio: 'Add Type',
        mestadoempleado: 'Employee Status Master',
        estadoempleado: 'Employee Status',
        edicionestadoempleado: 'Employee Status Edition',
        cargaestadoempleado: 'Employee Status Creation',
        insertarestadoempleado: 'Insert an employee status',
        empleado: 'Employee',
        empleados: 'Employees',
        estado: 'Status',
        apellido: 'Surname',
        telefono: 'Phone',
        costohoras: 'Hourly rate',
        costohorasextra: 'Overtime rate',
        mempleado: 'Employee Master',
        insertarempleado: 'Insert an Employee',
        insertarnombre: 'Insert name',
        insertarapellido: 'Enter surname',
        seleccionarcodigoestado: 'Select a Status Code',
        agregarestado: 'Add an status',
        ingresarcostohorasextra: 'Enter overtime rate',
        ingresartelefono: 'Enter a phone number',
        edicionempleado: 'Employee Edition',
        cargaempleado: 'Employee Creation',
        seleccionarusuario: 'Select an user',
        agregarusuario: 'Add an user',
        mubicacion: 'Location Master',
        ubicacion: 'Location',
        edicionubicacion: 'Location Edition',
        cargaubicacion: 'Location Creation',
        ingresarubicacion: 'Enter a location',
        msocionegocioubicacion: 'Location Business Partner Master',
        socionegocioubicacion: 'Location Business Partner',
        edicionsocionegocioubicacion: 'Business Partner Location Edition',
        cargasocionegocioubicacion: 'Business Partner Location Creation',
        seleccionarsocionegocio: 'Select a Business partner',
        seleccionarubicacion: 'Select a location',
        agregarubicacion: 'Add location',
        codigosocionegocio: 'BP Code',
        descripcionsocionegocio: 'BP Desc.',
        codigoubicacion: 'Location Cod',
        descripcionubicacion: 'Location Desc.',
        mherramienta: 'Tool Master',
        herramientas: 'Tools',
        edicionherramienta: 'Tool Edition',
        cargaherramienta: 'Tool Creation',
        ingresarherramienta: 'Enter a tool',
        logooilone: 'OilOne Logo',
        seleccionaridioma: 'Select lenguage',
        selecionaritem: 'Select an item from the list',
        crearnuevo: 'Create new',
        ingresarcodigo: 'Enter a code...',
        datosincompletos: 'Data was missing',

        logoeamone: 'EAMOne logo',
        equipo: 'Equipment',
        fechaalta: 'Entry date',
        tablerocontrol: 'Dashboard',
        marca: 'Brand',
        modelo: 'Model',
        numeroserie: 'Serial#',
        numerofabricacion: 'Creator #',
        largo: 'Long',
        ancho: 'Width',
        alto: 'high',
        peso: 'Weight',
        responsable: 'Responsible',
        dominio: 'Plate',
        cargaequipo: 'Equipment creation',
        edicionequipo: 'Equipment edition',
        mequipo: 'Equipment Master',
        descripcionrequerida: 'Description is required',
        fecharequerida: 'Date is required',
        estadoequipo: 'Equipment status',
        estadoinicialequipo: 'Initial setup',
        equipopadre: 'Equipment\'s parent',
        activofijo: 'Fixed asset',
        criticidad: 'Criticality',
        mcriticidad: 'Criticality Master',
        volumen: 'Volume',
        cargo: 'Position',
        conductor: 'Driver',
        tipoequipo: 'Equipment type',
        mactivofijo: 'Fixed Asset Master',
        mtipoequipo: 'Equipment Type Master',
        mestadoequipo: 'Equipment Status Master',
        edicioncriticidad: 'Criticality edition',
        cargacriticidad: 'Criticality creation',
        edicionactivofijo: 'Fixed asset edition',
        cargaactivofijo: 'Fixed asset creation',
        ediciontipoequipo: 'Equipment type edition',
        cargatipoequipo: 'Equipment type creation',
        edicionestadoequipo: 'Equipment status edition',
        cargaestadoequipo: 'Equipment status creation',
        filtroequipo: 'Equipment filter',
        padre: 'Father',
        seleccionarpadre: 'Select a father',
        errorobteniendodatos: 'Error during data getting',
        nombres: 'Names',
        apellidos: 'Surnames',
        seguroelimina: 'Item will be eliminated. Are you sure?',
        mtipoempleado: 'Employee Types Master',
        tipoempleado: 'Employee Type',
        tiposempleaso: 'Employee Types',
        ediciontipoempleado: 'Employee Type Edition',
        cargatipoempleado: 'Employee Type Creation',
        edicionsegtarea: 'Security Task Edition',
        cargasegtarea: 'Security Task Creation',
        textona: 'N/A',
        mtablas: 'Tables Master',
        tabla: 'Table',
        tablas: 'Tables',
        seleccionartabla: 'Select a table',
        ediciontabla: 'Table edition',
        cargatabla: 'Table creation',
        tablagenericanoencontrada: 'Table Not found',
        valor: 'Value',
        valores: 'Values',
        dimensionescontables: 'Accounting dimensions',
        dimension: 'Dimension',
        seleccionardimension: 'Select a dimension',
        msyncprocesos: 'Synchronization Logs',
        syncproceso: 'Synchronization Log',
        numeroproceso: 'Process #',
        tipoejecucion: 'Execution',
        withproblems: 'With Problems',
        ok: 'OK',
        manual: 'Manual',
        logdetalle: 'Log Details',
        logdocobjectcode: 'Object Code',
        cantprocesados: 'Qty processed',
        cantsincronizados: 'Qty Synchronized',
        procesofinalizado: 'Process completed',
        procesofinalizadoconproblemas: 'Process completed with problems',
        sinmodulosactivos: 'Tenant does not have active Modules',

        importardatosmaestros: 'Import Master Data',
        formatonovalido: 'No valid format',
        arrastrarysoltarexel: 'Drag & Drop an Excel file into this place to process it',
        importardatos: 'Import',
        archivovalidado: 'Validated',
        archivovalido: 'Valid',
        archivonovalido: 'Invalid',
        procesamientocorrecto: 'Processing completed successfully',
        procesamientocorrectoconproblemas: 'Processing completed with problems',
        inquilinotarget: 'Target Tenant',
        nombrearchivo: 'File Name',

        admin_abm: '',
        admin_abm_seg_tareas: '',
        admin_seg_tarea_perfil: '',
        admin_ver_seg_tareas: '',
        check_abm: '',
        check_crear: '',
        check_ver: '',
        docu_abm: '',
        docu_crear: '',
        docu_ver: '',
        general_abm: '',
        mant_abm: '',
        mant_ver_medicion: 'View Measurements',
        mant_crear_medicion: 'Create Measurements',
        mant_crear_ot: '',
        mant_crear_sol: '',
        mant_ver_ot: '',
        mant_ver_estado: 'Equipment status',
        mant_ver_talleres: 'View Workshops',
        mant_abm_talleres: 'Create, update and delete Workshops',
        mant_st: '',
        mant_st_draft: '',
        mant_sc: '',
        mant_sc_draft: '',
        mant_ver_sol: '',
        mant_vista_plan: '',
        mant_vista_seguim: '',
        mant_vista_solic: '',
        parte_abm: '',
        parte_crear: '',
        parte_ver: '',
        solo_propio_parte: '',
        requieregeoreferencia: 'Register Geo-Reference',

        upartone: 'PARTONE_Visible',
        ucheckone: 'CHECKONE_Visible',
        ueamone: 'EAMONE_Visible',
        udocuone: 'DOCUONE_Visible',
        mpartone: 'PARTONE',
        mcheckone: 'CHECKONE',
        meamone: 'EAMONE',
        mdocuone: 'DOCUONE',

        datorazonsocialyaregistrado: 'Company name already registered in another Tenant',
        nombreitemyaregistrado: 'Ya existe un item registrado con este nombre',

        /* ****************************************************************************** */
        /* *********** PARTE DIARIO ****************************************************** */
        tareaparte: 'Daily report task',
        mtarea: 'Task Master',
        ediciontareaparte: 'Report Task Edition',
        cargatareaparte: 'Report Task Creation',
        ingresartareaparte: 'Enter a report task',
        numeroparte: 'Part #',
        observaciones: 'Comments',
        cliente: 'Client',
        fecha: 'Date',
        hora: 'Time',
        eliminar: 'Delete',
        observacionespublicas: 'Observations (publics)',
        observacionesprivadas: 'Observations (privates)',
        firmadigital: 'Signature',
        firmasdigitales: 'Signatures',
        comentarios: 'Comments',
        cargapartediario: 'Daily report creation',
        edicionpartediario: 'Daily report edition',
        agregarfila: 'Add a row',
        agregartarea: 'Add a task',
        descargar: 'Download',
        seleccionarfecha: 'Select a date',
        tareas: 'Tasks',
        horainicio: 'Starting time',
        horafin: 'Ending time',
        privado: 'Privated',
        facturable: 'Billable',
        cantidadhoras: 'Hours Qty.',
        detallepartediario: 'Daily report detail',
        cerrarparte: 'Close report',
        primerparte: 'First report',
        parteanterior: 'Previous report',
        partesiquiente: 'Next report',
        ultimoparte: 'Last report',
        detalle: 'Details',
        anexo: 'Attachments',
        arrastrarysoltar: 'Drag & Drop files into this place to upload',
        buscararchivos: 'Browse files',
        campousuario: 'User fields',
        tamanio: 'Size',
        obligatorio: 'Required',
        mcampousuario: 'User Field Master',
        edicioncampousuario: 'User field edition',
        cargacampousuario: 'User field creation',
        nombrecampo: 'Field name',
        tipocampo: 'Field type',
        seleccionartipo: 'Select a type',
        cabecera: 'Header',
        pie: 'Footer',
        ingresartamanio: 'Enter the size',
        modelosparte: 'Daily Report Models',
        modeloparte: 'Daily report model',
        composusuario: 'User fields',
        proximo: 'Next number',
        edicionmodelo: 'Daily report models edition',
        cargamodelo: 'Daily report models creation',
        nombrerequerido: 'Name is required',
        nuevocampo: 'New user field',
        campousuariodisponible: 'Available user fields',
        campousuarioseleccionado: 'Selected user fields',
        modelobase: 'Base model',
        comentarioscliente: 'Client\'s Comments',
        errorguardar: 'Error on Saving data',
        partecerrado: 'Report closed',
        segurocerrar: 'Report will be closed. Are you sure?',
        cerrar: 'Close',
        seleccionarmodelo: 'Select a model',
        grupocampousuario: 'User fields groups',
        mgrupocampousuario: 'User Field Group Master',
        ediciongrupocampousuario: 'User field group edition',
        cargagrupocampousuario: 'User field group creation',
        nombregrupocampo: 'Group name',
        agruparen: 'Group in',

        /* ************************************************************************************************ */
        /* ***************************************** CONTROL DOCUMENTAL ***************************************** */

        tipodocumentacion: 'Documentation type',
        ediciontipodocumentacion: 'Documentation type edition',
        cargatipodocumentacion: 'Documentation type creation',
        documentacion: 'Documentation',
        mdocumentacion: 'Documentation Master',
        mtipodocumentacion: 'Documentation Type',
        ediciondocumentacion: 'Documentation edition',
        cargadocumentacion: 'Documentation creation',
        tipodocumentacionrequerido: 'Documentation type is required',
        agregartipo: 'Add new type',
        mrecursodocumentacion: 'Resource\'s documentation Master',
        recursodocumentacion: 'Resource\'s documentation',
        tiporecurso: 'Resource type',
        vencimiento: 'Expiration',
        edicionrecursodocumentacion: 'Resource\'s documentation edition',
        cargarecursodocumentacion: 'Resource\'s documentation creation',
        selecionartiporecurso: 'Select a resource type',
        tiporecursorequerido: 'Resource type is required',
        selecionarrecurso: 'Selecgt a resource',
        recursorequerido: 'Resource is required',
        documentacionrequerida: 'Documentation is required',
        recurso: 'Resource',
        numerovigente: 'Valid number',
        fechaemision: 'Issue date',
        fechaalerta: 'Expiry alert',
        fechavencimiento: 'Expiry date',
        costo: 'Cost',
        agregarrecurso: 'Add a resource',
        nueva: 'New',
        msocionegociodocumentacion: 'Business Partner Documentation Master',
        socionegociodocumentacion: 'Business Partner Documentation',
        inhabilita: 'Disables',
        edicionsocionegociodocumentacion: 'Business partner documentation edition',
        cargasocionegociodocumentacion: 'Business partner documentation creation',
        si: 'Yes',
        no: 'No',
        posicion: 'Position',
        seleccionarposicion: 'Select a position',
        activo: 'Active',
        inactivo: 'Inactive',
        georeferenciacion: 'Geo-Reference',
        documentacionnovigente: 'Not current',
        documentacionvigente: 'Current',
        documentacionporvencer: 'Close to overdue Docs',
        documentacionvencida: 'Overdue Docs',


        /* ************************************************************************************************ */
        /* ***************************************** CHECK LIST***************************************** */
        mmodelochecklist: 'Checklist Model Master',
        mcomponentecheck: 'Checklist Component Master',
        componentecheck: 'Checklist Component',
        cargacomponentecheck: 'Checklist Component Creation',
        edicioncomponentecheck: 'Checklist Component Edition',
        mtiporecurso: 'Resource Type Master',
        ediciontiporecurso: 'Resource Type Edition',
        cargatiporecurso: 'Resource Type Creation',
        recursos: 'Resources',
        campos: 'Fields',
        cargamodelocheck: 'Checklist Model Creation',
        edicionmodelocheck: 'Cheklist Model Edition',
        recursosdisponibles: 'Available resources',
        recursosseleccionados: 'Selected resources',
        seleccionartodos: 'Select all',
        eliminartodos: 'Unselect all',
        camposdisponibles: 'Available fields',
        camposseleccionados: 'Selected fields',
        usuariosdisponibles: 'Available users',
        usuariosseleccionados: 'Selected users',
        modeloscheck: 'Checklist Models',
        edicionchecklist: 'Checklist Edition',
        cargachecklist: 'Checklist Creation',
        detallechecklist: 'Checklist Detail',
        numerocheck: 'Checklist #',

        noeditaelemento: 'Can\'t edit this element',
        elementoguardado: 'Element saved successfully',
        componentesdisponibles: 'Available Components',
        componentes: 'Components',
        asociarrecursos: 'Associate to Resources',
        asociarusuarios: 'Associate to Users',

        /********************************************************************************************************************************** */
        /*************** MANTENIMIENTO********************************************************************************************* */

        articuloprevisto: 'Expected item',
        articulosprevistos: 'Expected items',
        marticuloprevisto: 'Expected Item Master',
        edicionarticuloprevisto: 'Expected Item Edition',
        cargaarticuloprevisto: 'Expected Item Creation',
        mrrhhprevisto: 'Expected Human Resources Master',
        rrhhsprevistos: 'Expected human resources',
        rrhhprevisto: 'Expected human resource',
        edicionrrhhprevisto: 'Expected Human Resource Edition',
        cargarrhhprevisto: 'Expected Human Resource Creation',
        mtareaprevista: 'Expected Task Master',
        ediciontareaprevista: 'Expected Task Edition',
        cargatareaprevista: 'Expected Task Creation',
        tareaprevista: 'Expected Tasks',
        mtiporesultado: 'Result Type Master',
        tiporesultado: 'Result Type',
        tiposresultado: 'Result Types',
        ediciontiporesultado: 'Result Type Edition',
        cargatiporesultado: 'Result Type Creation',
        mtipofrecuencia: 'Frequency Type Master',
        tiposfrecuencia: 'Frequency Types',
        tipofrecuencia: 'Frequency Type',
        tiposmedicion: 'Measurement Types',
        ediciontipofrecuencia: 'Frequency Type Edition',
        cargatipofrecuencia: 'Frequency Type Creation',
        mestadoot: 'Work Orders Status Master',
        estadoot: 'Work Orders Status',
        edicionestadoot: 'Work Order Edition',
        cargaestadoot: 'Work Order Creation',
        msolicitante: 'Applicants Master',
        solicitante: 'Applicant',
        solicitantes: 'Applicants',
        edicionsolicitante: 'Applicant Edition',
        cargasolicitante: 'Applicant Creation',
        mprioridad: 'Priorities Master',
        prioridad: 'Priority',
        prioridades: 'Priorities',
        edicionpriodidad: 'Priority Edition',
        cargaprioridad: 'Priority Creation',
        mestadosolicitud: 'Request Status Master',
        estadosolicitud: 'Request Status',
        edicionestadosolicitud: 'Request Status Edition',
        cargaestadosolicitud: 'Request Status Creation',
        generasolicitud: 'Creates Request',
        generasolicitudobservaciones: 'Explanation',
        generasolicitudlimite: 'Limit',
        generasolicitudvalor: 'Actual value',
        mtipomantenimiento: 'Maintenance Type Master',
        mtipomedicion: 'Measurement Type Master',
        mtalleres: 'Workshops Master',
        taller: 'Workshop',
        talleres: 'Workshops',
        cargataller: 'Workshop Creation',
        ediciontaller: 'Workshop Edition',
        asignarusuariosataller: 'Assign users to workshop',
        tipomantenimiento: 'Maintenance Types',
        ediciontipomantenimiento: 'Maintenance Type Edition',
        cargatipomantenimiento: 'Maintenance Type Creation',
        ediciontarea: 'Task Edition',
        cargatarea: 'Task Creation',
        selecionartiporesultado: 'Select a result type',
        msolicitudmantenimiento: 'Maintenance Requests Master',
        solicitudmantenimiento: 'Maintenance Request',
        solicitudesmantenimiento: 'Maintenance Requests',
        seguimientosolicitudesmantenimiento: 'Maintenance Requests Followup',
        planificacion: 'Planning',
        edicionsolicitudmantenimiento: 'Maintenance Request Edition',
        cargasolicitudmantenimiento: 'Maintenance Request Creation',
        numero: 'Number',
        numeroot: '#WO',
        ordentrabajo: 'Work Order',
        codigoequipo: 'Equipment Code',
        descripcionequipo: 'Equipment Desc.',
        plan: 'Plan',
        nombreplan: 'Plan name',
        crearot: 'Create WO',
        ignorar: 'Ignore',
        seguroignorar: 'This will IGNORE the Maintenance Request. Are you sure?',
        segurocancelar: 'This will CANCEL the Maintenance Request. Are you sure?',
        mordenestrabajo: 'Work Orders Master',
        segurocancelarot: 'This will CANCEL the Work Order. Are you sure?',
        segurofinalizarot: 'This will CLOSE the Work Order. Are you sure?',
        ordenestrabajo: 'Work Orders',
        edicionordentrabajo: 'Work Order Edition',
        cargaordentrabajo: 'Work Order Creation',
        solicitud: 'Request',
        descripcionactivofijo: 'Fixed Asset Desc.',
        codigotarea: 'Task Code',
        descripciontarea: 'Task Desk',
        tarea: 'Task',
        descripciontiporesultado: 'Result Type Desc.',
        check: 'Check',
        resultado: 'Result',
        fechainicio: 'Start Date',
        fechafin: 'End Date',
        ejecutante: 'Performer',
        observacion: 'Observation',
        rrhhprev: 'Exp. HHRR',
        descripciontiporecurso: 'Resource Type Desc.',
        horasprevistas: 'Expected hours',
        articulosprev: 'Expected Articles',
        articulosreq: 'Req. Articles',
        cantidad: 'Qty',
        tipomedicion: 'Measurement Type',
        valormedicion: 'Measurement Value',
        fechamedicion: 'Measurement Date',
        usuariomedicion: 'Measurement User',
        contadores: 'Counters',
        motivo: 'Reason',
        mediciones: 'Measurements',
        crearmedicion: 'New Measurement',
        edicionmedicion: 'Modify Measurement',
        medicion: 'Measurement',
        planmantenimiento: 'Maintenance Plan',
        planesmantenimiento: 'Maintenance Plans',
        edicionplanmantenimiento: 'Maintenance Plan Edition',
        cargaplanmantenimiento: 'Maintenance Plan Creation',
        frecuencia: 'Frequency',
        equiposdisponibles: 'Available equipments',
        equiposseleccionados: 'Selected equipments',
        asignarplanaequipos: 'Assign plan to equipments',
        codequipo: 'Equipment Code',
        tiporrhhprevisto: 'Expected HHRR Type',
        tiposrrhhprevisto: 'Expected HHRR Types',
        mtiposrrhhprevisto: 'Expected HHRR Types Master',
        ediciontiporrhhprevisto: 'Expected HHRR Type Edition',
        cargatiporrhhprevisto: 'Expected HHRR Type Creation',
        nombreejecutante: 'Performer Name',
        algoritmo: 'Generates Maintenance Requests',
        vertodas: 'Show All',
        descargaarchivoexcel: 'Export to Excel',
        actualizar: 'Refresh',
        costomantenimiento: 'Maintenance Costs',
        costos: 'Costs',
        disponibilidadequipos: 'Equipment Availability',
        codigoestado: 'Status Code',
        descripcionestado: 'DeStatus Description',
        nombreestado: 'Status',
        informeequipos: 'Equipment report',
        reportecostomantenimiento: 'Maintenance Cost Report',
        reportehistorialubicacion: 'Location History Report',
        reporteequipos: 'Equipment Report',
        reportedisponibilidadequipos: 'Equipment Availability Report',
        reportetareaspendientes: 'Pending Tasks Report',
        nombreubicacion: 'Location',
        nombresocionegocio: 'Business Partner',
        nombretiposocionegocio: 'Business Partner Type',
        reporteordentrabajo: 'Work Orders Report',
        codigotipomantenimiento: 'Maint.Type Code',
        codigousuario: 'User Code',
        codigoprioridad: 'Priority Code',
        numerosolicitud: 'Requirement No.',
        fechasolicitud: 'Requirement Date',
        codigoplanmantenimiento: 'Maint.Plan Code',
        descripcionplanmantenimiento: 'Maint.Plan Desc.',
        codigoempleado: 'Employee Code',
        nombresempleado: 'Employee Name',
        apellidosempleado: 'Employee Surname',
        nombrecompletoempleado: 'Employee Full Name',
        stock: 'Stock',
        sindatos: 'Without data',
        pedir: 'Require',
        asolicitar: 'To be required',
        resultadosincronizacion: 'Sync result',
        sinmensaje: 'Without message',
        consulteresgistrosync: 'Review Sync logs',
        syncexitosa: 'Successful sync',
        syncfinalizadoconproblemas: 'Sync completed with problems',
        errorsincronizacion: 'Error within Sync',
        huboerrorsincronizar: 'There was an error sync',
        errorcrearsyncproceso: 'Error creating process',
        sistemanosoportado: 'Unsupported system',
        inquilinonoencontrado: 'Tenant Not found',
        errorvalidacionparametrossap: 'SAP parameter validations failed',
        historialot: 'WO History',
        unicoejecutante: 'Sole Performer',
        datosunicos: 'Single data',
        docscprelim: 'Purchase Request',
        docstprelim: 'Transfer Request',
        docsc: 'Purchase Request',
        docst: 'Transfer Request',
        finalizarot: 'Close WO',
        obtenerstockSAP: 'Retrieve SAP stock details',
        operacionexitosa: 'Operation completed successfully',
        tiposolicitudb1invalido: 'Invalid request type',
        otnoencontrada: 'OT Not found',
        usuarionoencontrado: 'User Not found',
        fallologinremoto: 'Remote login failed',
        fallocreardraft: 'Draft create failed',
        errorenconexionServiceLayer: 'There was an error connecting to Service Layer',
        itemnoencontrado: 'Item Not found',
        itemalreadyunsubscribe: 'Item has already been unsubscribe',
        generar: 'Generate',
        otsolplansincontadores: 'WO comes from an auto-generated request, but has no new counter value',
        otdatosunicosnouniformes: 'With single data enabled, all tasks must have the same performer and the same start/end date and time. Use the "Single data" fields to unify them.',
        medicionnoencontrada: 'Measurement type Not found',
        medicionmanual: 'Cannot manually enter a date measurement',
        medicioninferior: 'Cannot enter a measurement lower than a previous one',
        medicionsuperior: 'Cannot enter a measurement greater than a later one',
        medicionequiponoencontrado: 'Cannot enter a measurement to non-existent or inactive Equipment',
        porcetajeotxtipomtto: '% of WO by Maintenance Type',

        deleteviolation: 'Cannot be deleted because it is being used',
        updateviolation: 'Cannot be updated because it is being used',
        planmantenimientonoencontrado: 'Maintenance Plan Not found',
        equiponoencontradooinactivo: 'Equipment Not found or Inactive',
        prioridadnoencontradooinactiva: 'Priority Type Not found or Inactive',
        tipomttonoencontradooinactivo: 'Maintenance Type Not found or Inactive',
        tallernoencontradoobaja: 'The selected workshop does not exist or was deleted',
        tallerinactivo: 'Cannot assign an inactive workshop',
        tallernoseleccionable: 'Not available for selection',
        tallernoperteneceusuario: 'The selected workshop does not belong to the user',
        sinpermisomodtallersolicitud: 'You are not authorized to change the request workshop',
        sinpermisomodtallerot: 'You are not authorized to change the WO workshop',

        cantsc: 'Qty Purchase Request',
        cantst: 'Qty Transfer Request',
        articulonoencontradooinactivo: 'Article(s) Not found or Inactive. Code(s): ',
        valorexcedemax: 'Entered value exceeds maximum allowed',
        articulosrepetidos: 'There are duplicate articles',
        fechaubicacion: "Assignment Date Location",
        exito: "Success",
        errorfechaubicacion: "Assignment Date Location cannot be less than the previous one",
        errorguardararticulos: 'Error saving articles',
        errorguardararticuloporduplicado: 'Duplicate items. If you want to change the quantity, do so directly on the item already uploaded.',
        tipomantnoencontrado: "Maintenance Type Not found",
        priotidadnoencontrada: "Priority Not found",
        estadosolnoencontrado: "Request Status Not Found",
        errorvalidarparametros: "Error validating parameters",
        soloarchivospng: "Only files in PNG format are allowed",
        nofile: "File not found",
        s3filenotfound: "An error occurred while trying to retrieve the file.",
        inquilinosinlogo: "Tenant logo not found. The default logo will be used",
        numerodocumento: 'Document No.',
        fechadocumento: 'Document Date',
        nombrecompleto: 'Full name',
        codigoarticulo: 'Article Code',
        descripcionarticulo: 'Article Description',
        pagina: 'Page',
        de: 'Of',
        reportehistorialestadoequipo: 'Equipment Status History Report',
        historialestadoequipo: 'Equipment Status History',
        fechaestado: "Assignment Date Status",
        formatoinvalido: 'Invalid format. Allowed: {ext}',
        aclaracion: "Printed name",
        mparametrosgenerales: "System Module General Parameters Master",
        tablagenerica: "Generic Table",
        texto: "Text",
        parametrogeneral: "General Parameter",
        parammodsistemanoencontrado: "System Module Parameter Not Found",
        modulo: "Module",
        parametrosgenerales: "General Parameters",
        registrosyscoreerror: "System internal records (SYSCORE) cannot be modified.",
        errorvalidacionparametros: 'Parameter validations failed',
        errorconfigtablausuarioeamone: 'The user table was not properly configured in EamOne.',
        errorinsertarequiposap: 'Error inserting equipment into SAP',
        errortablausuariosap: 'Verify that the user table exists in SAP and contains all the columns.',
        notienepermiso: "You are not authorized to perform this action",
        gestionmantenimientos: 'Maintenance Management',
        estadoinicial: 'Initial status',
        yaexisteunestadoinicial: 'There is already a work order status marked as the initial status',
        restriccionestadoinicialinactivo: 'Cannot mark as inactive an initial status',
        historialestadoot: 'WO Status History',
        mtranestadosot: 'Work Order State Transition Master',
        estadoorigen: 'Origin status',
        estadodestino: 'Destination status',
        tipoasignacion: 'Assignment type',
        editable: 'Editable',
        noencontrado: 'Record not found',
        transicionestadoot: 'Transitions of Work Order Status',
        ediciontransicionestadoot: 'Edit The Transition Status',
        cargatransicionestadoot: 'Load The Transition Status',
        elregistroyaexiste: 'The record already exists',
        errordestinoestadoinicial: 'The destination status cannot be the initial status',
        estadoorigennovalido: 'A valid origin status must be provided.',
        estadodestinonovalido: 'A valid destination status must be provided.',
        estadoorigenigualestadodestino: 'The origin status cannot be the same as destination status',
        nosepuedeeditar: 'The record cannot be edited',
        nosepuedeeliminar: 'The record cannot be deleted',
        perfilesinvalidos: 'The profiles field is invalid.',
        usuariosinvalidos: 'The users field is invalid.',
        perfilousuariorequerido: 'You must select at least one profile or user.',
        perfilesautorizados: 'Authorized Profiles',
        usuariosautorizados: 'Authorized Users',
        errortareaseguridad: 'It was not possible to generate the security task for the transition.',
        registrosystemcore: 'This record cannot be edited because it belongs to the system',
        elimregistrosystemcore: 'This record cannot be deleted because it belongs to the system',
        cuidado: '¡Warning!',
        importante: 'Important',
        apikeydadadebaja: 'This API Key is deactivated.',
        UniqueUsuarioFechaModeloViolation: "Cannot be created or modified with the indicated parameters because another one already exists",
        SequelizeForeignKeyConstraintError: "The operation cannot be performed because it is already in use",
        SequelizeUniqueConstraintError: "The operation cannot be performed because data with the entered value already exists",
        ExecConstraints: "The operation cannot be performed because the restrictions are not met",
        valuemustnotbenegative: "The value field cannot be a negative number",
        equiposintipomedicionerror: "Cannot enter a measurement into equipment that don't have measurement types",
        tipomedicionnoasociadoalequipo: "The measurement type is not associated with the equipment",
        valuetoolong: "Value too Long",
        valueoutofrange: "The value is out of range",
        versolicitud: "View Request",
        tituloasunto: "Request Title",
        observacionot: "WO Observation",
        codigoitemyaregistrado: 'An item with this code already exist.',
        estadootnoencontrado: 'WO Status not found.',
        errorbajaestadoot: 'Error deleting OT status.',
        errorbajatransicionestadoot: 'Error deleting the WO status transition.',
        operacionnopermitidaporestadoot: 'The operation cannot be performed due to the WO status',
        loginintegradocon: 'Integrated with',

        usardatosunicos: 'Use single data (performer and date/time shared by all tasks)',
        horainicioot: 'WO Start Time',
        fechafinalizacioncomprometida: 'Committed End Date',
        horafinalizacioncomprometida: 'Committed End Time',
        fechafinantesinicio: 'The committed end date and time cannot be earlier than the start date and time.',
        fechahorainicioot: 'Planning start date and time',
        fechahorafinot: 'Planning end date and time',
        ordenar: 'Sort',
        ordenarpor: 'Sort by',
        direccionorden: 'Direction',
        ascendente: 'Ascending',
        descendente: 'Descending',
        seleccionecolumna: 'Select a column',
        primera: 'First',
        anterior: 'Previous',
        siguiente: 'Next',
        ultima: 'Last',
        mostrar: 'Show',
        registros: 'records',
        sincoincidencias: 'No matches found in the loaded records',
        pruebebusquedaavanzada: 'Try the advanced search',
        restablecer: 'Reset',
        restablecervista: 'Clear filters and sorting',
        sinresultadosbusqueda: 'The search returned no records',
        busquedaavanzada: 'Advanced search',
        limpiar: 'Clear',
        todos: 'All',
        mprogramacionesprocesos: 'Automatic execution schedules',
        proceso: 'Process',
        diassemana: 'Days of the week',
        horario: 'Time',
        domingo: 'Sunday',
        lunes: 'Monday',
        martes: 'Tuesday',
        miercoles: 'Wednesday',
        jueves: 'Thursday',
        viernes: 'Friday',
        sabado: 'Saturday',
        cargaprogramacionproceso: 'Automatic execution schedule creation',
        edicionprogramacionproceso: 'Automatic execution schedule editing',
        frecuenciainvalida: 'The frequency entered is not valid',
        procesonoencontrado: 'Process not found or inactive',
        auto: 'Automatic',
        codigoprogramacionexistente: 'A schedule with the entered code already exists',
        fechaot: 'WO date',
        fechainicioejecucion: 'Execution start date',
        fechafinejecucion: 'Execution end date',
        horainicioejecucion: 'Execution start time',
        horafinejecucion: 'Execution end time',
        sinpermisoeditarfechasot: 'You are not authorized to enter or change the WO planning dates',
        sinarticulossolicitud: 'Select at least one article with a pending quantity to create the request',
        articulonopendienteot: 'Only work order articles can be requested, up to the pending quantity',
    }
}
